define('chatInboxRouter',[
  'require',
  'exports',
  'module',
  'marionette',
  'app',
  'itemPagesNameMixin'
], function (require, exports, module, Marionette, App, ItemPagesNameMixin) {
  'use strict';

  var ChatInboxRouter = Marionette.AppRouter.extend({
    appRoutes: {
      'chat-inbox': 'showList',
      'chat-inbox/:secId': 'showDetail'
    }
  });

  /**
   * Resolve the content region, but only if it's safe to show into. The
   * showContent() deferred is async (first navigation runs a long account/
   * roles bootstrap), so by the time it resolves the user may have routed
   * elsewhere — showing our view then would both clobber their page and,
   * if the main view was swapped, render into a stale/destroyed region
   * (ViewDestroyedError). `expectedRoute` guards against that: bail unless
   * the current route still matches the one that started this navigation.
   */
  function safeContentRegion(expectedRoute) {
    if (App.getCurrentRoute() !== expectedRoute) { return null; }
    var mainView = App.regions.getRegion('main').currentView;
    if (!mainView || mainView.isDestroyed || !mainView.getRegion) { return null; }
    var region = mainView.getRegion('content');
    return (region && !region.isDestroyed) ? region : null;
  }

  var API = {
    // Both routes render the same split (list + detail) view. When it's
    // already on screen we reuse it — only swapping the right pane — so
    // navigating between conversations never tears down the live list pane.
    showList: function () {
      require([
        'chatInboxView',
        'contentShowController'
      ], function (ChatInboxView, ContentShowController) {
        ContentShowController.showContent().done(function () {
          var region = safeContentRegion('chat-inbox');
          if (!region) { return; }
          var current = region.currentView;
          if (current instanceof ChatInboxView && !current.isDestroyed) {
            current.clearSelection();
          } else {
            region.show(new ChatInboxView());
          }
          App.execute('set:active:nav:item', ItemPagesNameMixin.CHAT_INBOX);
        });
      });
    },

    showDetail: function (secId) {
      require([
        'chatInboxView',
        'contentShowController'
      ], function (ChatInboxView, ContentShowController) {
        ContentShowController.showContent().done(function () {
          var region = safeContentRegion('chat-inbox/' + secId);
          if (!region) { return; }
          var current = region.currentView;
          if (current instanceof ChatInboxView && !current.isDestroyed) {
            current.selectSession(secId);
          } else {
            region.show(new ChatInboxView({ selectedSecId: secId }));
          }
          App.execute('set:active:nav:item', ItemPagesNameMixin.CHAT_INBOX);
        });
      });
    }
  };

  App.on('before:start', function () {
    new ChatInboxRouter({ controller: API });
  });

  module.exports = ChatInboxRouter;
});

